'use strict';

(function () {
    'use strict';

    angular.module('damages.scheduleDepa', ['ui.router', 'common']);
})();